import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend ,CategoryScale,registerables} from "chart.js";
import { Bar, Line, Pie } from "react-chartjs-2";
import zoom from 'chartjs-plugin-zoom'
import { getBoundingClientRect } from "../../utils/functions";
// import { lineArc } from "@turf/turf";

ChartJS.register(ArcElement, Tooltip, Legend,CategoryScale);
ChartJS.register(...registerables);



class WorkLoadChart extends React.Component {
    state = {
        show: true,
        type: 'line',

        data: {
            labels: ["Jan", "Fed", "Mar", "Apr", "May", 'Jun', "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

            datasets: [
                {
                    label: 'Humidity',
                    data: [1, 2, 4, 2, 5, 1],
                    fill: false,
                    backgroundColor: 'rgb(169, 212, 125)',
                    borderColor: 'rgba(169, 212, 125)',
                    // yAxisID: 'y-axis-1',
                },
            ]
        },

        thing: {},
        // topicId: nanoid(10),

        timeChartOptions: {
            bezierCurve: false,

            zoom: {
                enabled: true,
                // drag:true,
                mode: 'xy',
                overScaleMode: 'y',
                modifierKey: 'shift',

                wheel: {
                    enabled: false,
                    modifierKey: 'shift',

                },


                drag: {
                    enabled: true,
                    modifierKey: 'shift',

                },

                pinch: {
                    enabled: true,
                    modifierKey: 'shift',

                },


            },

            scales: {
                xAxes: [

                    {
                        gridLines: {
                            color: 'transparent',


                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                        }
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            color: "#eeeeeeFF"

                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                        }
                    },
                ],


            }
        },

    }


    options = {
        scales: {
            xAxes: [

                {
                    gridLines: {
                        color: 'transparent',
                        display: false


                    },
                    ticks: {
                        beginAtZero: true,
                        fontColor: '#afafaf',
                        fontSize: 12,
                    },

                },
            ],

            yAxes: [
                {
                    type: this.props.chartType,
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',

                },
            ],
        },
    }

    colors = [
        { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
        { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
        { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
    ]



    componentDidMount() {
        window.addEventListener('resize', this.getSize)
        this.getSize()
        // Chart.register(zoom)
        // Bar.register(zoom)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }


    render() {
        return (
            <div className={' thingInfoList '}>
                <div className="w-100">
                    <div style={{ border: '1px solid #ebeaf2', background: '#f9f9fb', borderRadius: 15 }}>
                        <div style={{}} className="d-flex justify-content-between p-3">
                            <div>
                                <p>Cash Flow</p>
                            </div>
                        </div>
                        <div className="row m-0" style={{ background: '#fff', borderBottomLeftRadius: 15, borderBottomRightRadius: 15 }}>
                            <div className="col-2 ">
                            </div>
                            {this.state.show && (
                                <div ref={el => this.chartContainer = el} style={{}} className="col-10 p-3">

                                    <Line
                                        data={this.state.data}
                                        // options={this.state.options}
                                        ref={el => this.chart = el}
                                        // height={this.state.width > 700 ? 130 : 300}
                                        height={this.state.width > 500 ? '30%' : '100%'}
                                        width={'100%'}
                                        // plugins={[zoom]}

                                    />
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default WorkLoadChart;

